import { Navigate, type RouteObject } from 'react-router';
import { CALLBACK_PATH } from '../auth/oidc';
import { CloudAccountsPage } from '../cloudAccounts/CloudAccountsPage';
import { DeploymentDetailPage } from '../deployments/DeploymentDetailPage';
import { DeploymentsPage } from '../deployments/DeploymentsPage';
import { AboutPage } from '../pages/AboutPage';
import { BlueprintListPage } from '../pages/BlueprintListPage';
import { VersionsPage } from '../pages/VersionsPage';
import { WhatsNewPage } from '../pages/WhatsNewPage';
import { NetworkingGate } from '../networks/NetworkingGate';
import { NetworkPage } from '../networks/NetworkPage';
import { NetworksPage } from '../networks/NetworksPage';
import { RunPage } from '../runs/RunPage';
import { RunsListPage } from '../runs/RunsListPage';
import { Loading } from '../components/ui';
import { AppLayout } from './AppLayout';
import { NotFound, OperatorsOnly } from './guards';

/** Routes of spec 6.1.6. */
export const routes: RouteObject[] = [
  { path: CALLBACK_PATH, element: <Navigate to="/" replace /> },
  {
    element: <AppLayout />,
    children: [
      { index: true, element: <Navigate to="/blueprints" replace /> },
      { path: 'blueprints', element: <BlueprintListPage /> },
      {
        // The designer (React Flow, rjsf, Ajv) is loaded on demand to keep the first load small.
        path: 'blueprints/:id',
        hydrateFallbackElement: <Loading />,
        lazy: async () => ({ Component: (await import('../designer/DesignerPage')).DesignerPage }),
      },
      { path: 'blueprints/:id/versions', element: <VersionsPage /> },
      { path: 'blueprints/:id/deployments', element: <DeploymentsPage /> },
      { path: 'deployments', element: <DeploymentsPage /> },
      { path: 'deployments/:id', element: <DeploymentDetailPage /> },
      // Feature spec 17: only while networking is on (else the switched-off text).
      {
        path: 'networks',
        element: (
          <NetworkingGate>
            <NetworksPage />
          </NetworkingGate>
        ),
      },
      {
        path: 'networks/:id',
        element: (
          <NetworkingGate>
            <NetworkPage />
          </NetworkingGate>
        ),
      },
      { path: 'runs', element: <RunsListPage /> },
      { path: 'runs/:id', element: <RunPage /> },
      // Master-detail (spec 6.6): the list and the open account are one page, so the list keeps its state.
      {
        path: 'cloud-accounts/:id?',
        element: (
          <OperatorsOnly>
            <CloudAccountsPage />
          </OperatorsOnly>
        ),
      },
      { path: 'about', element: <AboutPage /> },
      { path: 'whats-new', element: <WhatsNewPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];
